import { Dialog, Transition } from "@headlessui/react";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { Fragment } from "react";
import { Voucher } from "../../../types/challenges";
import { OwnedNft } from "../../../types/alchemy";
import VoucherDetails from "./VoucherDetails";
import RewardDetails from "./RewardDetails";

type LearnMoreModalProps = {
  reward: Voucher | OwnedNft | undefined; //reward will either be unused/claimable (ownedNFT) or used (voucher)
  closeModal: () => void;
};
export default function LearnMoreModal({
  reward,
  closeModal,
}: LearnMoreModalProps) {
  if (!reward) {
    return <></>;
  }

  const rewardIsVoucher = isVoucher(reward);

  return (
    <>
      <Transition
        appear
        show={!!reward}
        as={Fragment}
      >
        <Dialog
          as="div"
          className="relative z-10"
          onClose={closeModal}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>

          <div className="fixed inset-0 top-16 md:top-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className=" border-2 border-black shadow-uiBoxShadowMisc bg-uptop-tan flex flex-col gap-4 max-w-sm   w-full transform overflow-hidden rounded-lg  py-4 px-8 text-left  transition-all">
                  <div className="flex flex-row ">
                    <Dialog.Title
                      as="h2"
                      className="w-full  my-auto font-exposure text-xl text-center md:text-left "
                    >
                      {rewardIsVoucher ? "Voucher" : "Reward"} Details
                    </Dialog.Title>
                    <button
                      onClick={closeModal}
                      className="btn-reverse btn-white  group p-2 rounded-md  w-fit  my-auto"
                    >
                      <CloseOutlined />
                    </button>
                  </div>
                  {rewardIsVoucher ? (
                    <VoucherDetails voucher={reward} />
                  ) : (
                    <RewardDetails reward={reward} />
                  )}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

function isVoucher(
  voucher: Voucher | OwnedNft | undefined,
): voucher is Voucher {
  return (voucher as Voucher)?.creditRemaining !== undefined;
}
